export default "__VITE_ASSET__ADEaM1zH__"